var _defs, _g, _g2, _path, _polygon, _polygon2, _g3, _rect, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 391.2 97.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        font-family: Times-Roman, Times;\n        font-size: 48.2px;\n      }\n\n      .st0, .st1, .st2, .st3, .st4 {\n        isolation: isolate;\n      }\n\n      .st2, .st3 {\n        font-family: ArialMT, Arial;\n      }\n\n      .st2, .st4 {\n        font-size: 12px;\n      }\n\n      .st5 {\n        fill: #f9ef1e;\n      }\n\n      .st3 {\n        fill: #fff;\n        font-size: 22.6px;\n      }\n\n      .st4 {\n        font-family: AdobeMyungjoStd-Medium-KSCpc-EUC-H, 'Adobe Myungjo Std';\n        font-weight: 500;\n      }\n\n      .st6 {\n        fill: #0d924b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(91.8 167.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u5357\u901A\u8F68\u9053\u4EA4\u901A"))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(95.3 202.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Nantong Rail Transit"))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.8,50.4c-11.8,4.3-17.9,10-17.9,16.7s.6,4.7,4.8,8.8c17.8,17.2,74.5,14.3,83.5-4.2,2.4-4.9,1.2-6.8-1.6-2.7-2.7,4-10.3,8.3-18.2,10.4-8.7,2.3-24.2,2.1-33.2-.5-4-1.1-10-2-13.3-2-6.5,0-7-.6-4.9-5.4.9-1.9.9-3.2-.1-5.5-1.7-4.2-.4-8.6,3.6-12.6s3.4-3.7,3.4-4c0-.8-2.2-.5-6.1,1Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "48.6 29.4 24.2 74.6 73.1 74.6 48.6 29.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "73.1 35.8 55.6 68.2 90.6 68.2 73.1 35.8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(108.7 74.6) scale(1 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BACKWOON"))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 313.3,
    y: 8.7,
    width: 74.7,
    height: 29.3,
    transform: "translate(3.4 -30.7) rotate(5)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st3",
    transform: "translate(315.7 28.7) rotate(5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CMMS"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.902349ce70790890e5aa9d7b3f01587e.svg";
export { ForwardRef as ReactComponent };